import { ReactNode } from 'react';
import styled from 'styled-components';

import Card from 'components/insights/layout/Card';
import { colors } from 'styles/theme/colors';
import { BodySmall, H3 } from 'styles/typography';
import FacilityNetworkStatusEmptyStateIcon from 'svg/FacilityNetworkStatusEmptyStateIcon';

type Props = {
  title: string;
  message: string;
  children?: ReactNode;
};

export default function FacilityNetworkStatusEmptyState({ title, message, children }: Props) {
  return (
    <Container data-testid='facility-network-status-empty-state'>
      <FacilityNetworkStatusEmptyStateIcon />
      <H3>{title}</H3>
      <BodySmall color={colors.black100}>{message}</BodySmall>
      {children}
    </Container>
  );
}

const Container = styled(Card)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 40px;
  text-align: center;
`;
